import React, { FC } from 'react';
import Avatar from '../../../../../../shared/Avatar';
import { format } from 'date-fns';
import { Log } from '../../../../../models/Task';
import cx from 'classnames';
import styles from './styles.module.css';
import { Button } from 'antd';
import { TaskLogDescription } from './TaskLogDescription';
import { Sparkles } from '../../../../../../../redesign/javascript/components/Sparkles';

type Props = {
  logs: Log[];
  isAdminView?: boolean;
  loading: boolean;
  canViewDescriptionChanges?: boolean;
};

const Logs: FC<Props> = ({
  logs,
  isAdminView,
  loading = false,
  canViewDescriptionChanges
}) => {
  const getDateTime = (date: string): number => new Date(date).getTime();

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Button type="link" loading className={styles.loadingButton}>
          Loading activity log...
        </Button>
      </div>
    );
  }

  return (
    <ul
      className={cx(styles.list, 'eventList')}
      onScroll={event => event.stopPropagation()}
    >
      {logs
        .filter(log => log && log.changesHtml) // getting rid of empty logs
        .sort((a, b) => getDateTime(b.createdAt) - getDateTime(a.createdAt))
        .map((log: Log) => {
          const isTitleChanged = log.changesHtml === 'changed title';
          const suggestedTitleChange =
            isTitleChanged && log.titles[1].includes(' (Suggested by AI)');
          return (
            <li
              key={log.id}
              className={cx(styles.listItem, {
                [styles.adminListItem]: isAdminView
              })}
            >
              <Avatar size="small" member={log.user} />
              <div className={styles.itemInner}>
                <p className={styles.itemInfo} title={log.createdAt}>
                  {format(new Date(log.createdAt), "MMM d 'at' h:mma")}
                </p>
                <p className={styles.item}>
                  <span className={styles.userName}>{log.user.name}</span>
                  {isTitleChanged && !log.titles[1]
                    ? 'removed title'
                    : log.changesHtml}
                  {suggestedTitleChange && (
                    <span className={styles.suggestedByAI}>
                      <Sparkles
                        className={styles.sparklesIcon}
                        linearGradient
                        size={14}
                      />
                      <span>Suggested by AI</span>
                    </span>
                  )}
                </p>
                {canViewDescriptionChanges && <TaskLogDescription log={log} />}
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default Logs;
